export default __webpack_public_path__ + "a2ed29599292fa4483a4d1e5d69bd05a.png";